import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { campaignAPI, donationAPI } from '../services/api';

const s = {
  page: { maxWidth: 1100, margin: '0 auto', padding: '3rem 2rem' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 380px', gap: '3rem', alignItems: 'start' },
  tag: { display: 'inline-block', background: '#edf7f2', color: '#1e6f3e', fontSize: '0.75rem', padding: '4px 12px', borderRadius: 100, border: '1px solid rgba(30,111,62,0.2)', fontWeight: 600, marginBottom: '1rem' },
  title: { fontFamily: 'Fraunces, serif', fontSize: '2rem', fontWeight: 600, color: '#1c1814', marginBottom: '0.75rem', lineHeight: 1.2 },
  meta: { display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem', flexWrap: 'wrap' },
  avatar: { width: 40, height: 40, borderRadius: '50%', background: '#fde8e4', color: '#c0392b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1rem' },
  creatorName: { fontWeight: 600, fontSize: '0.9rem', color: '#1c1814' },
  role: { fontSize: '0.75rem', color: '#7a6f65' },
  verified: { background: '#edf7f2', color: '#1e6f3e', fontSize: '0.72rem', padding: '3px 10px', borderRadius: 100, border: '1px solid rgba(30,111,62,0.2)', fontWeight: 600 },
  story: { fontSize: '1rem', color: '#3d3530', lineHeight: 1.9, marginBottom: '2rem', whiteSpace: 'pre-wrap' },
  donorList: { marginTop: '2rem' },
  donorTitle: { fontWeight: 600, fontSize: '0.9rem', color: '#1c1814', marginBottom: '1rem' },
  donorItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 0', borderBottom: '1px solid #e2dbd0' },
  donorName: { fontWeight: 500, fontSize: '0.875rem', color: '#1c1814' },
  donorAmt: { fontWeight: 600, color: '#c0392b', fontSize: '0.875rem' },
  donorMsg: { fontSize: '0.8rem', color: '#7a6f65', fontStyle: 'italic', marginTop: '0.2rem' },
  sideCard: { background: '#fff', border: '1.5px solid #e2dbd0', borderRadius: 20, padding: '1.75rem', position: 'sticky', top: '90px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' },
  raised: { fontFamily: 'Fraunces, serif', fontSize: '2rem', fontWeight: 600, color: '#1c1814', marginBottom: '0.2rem' },
  raisedSub: { fontSize: '0.8rem', color: '#7a6f65', marginBottom: '1rem' },
  progTrack: { background: '#f4f0e8', borderRadius: 100, height: 10, overflow: 'hidden', marginBottom: '0.5rem' },
  progFill: { height: '100%', background: 'linear-gradient(90deg, #1e6f3e, #27ae60)', borderRadius: 100 },
  statsRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', margin: '1.25rem 0' },
  statBox: { background: '#faf7f2', borderRadius: 10, padding: '0.75rem', textAlign: 'center' },
  statN: { fontFamily: 'Fraunces, serif', fontSize: '1.4rem', fontWeight: 600, color: '#1c1814' },
  statL: { fontSize: '0.72rem', color: '#7a6f65' },
  divider: { borderTop: '1px solid #e2dbd0', margin: '1.25rem 0' },
  donateBtn: { width: '100%', background: '#c0392b', color: '#fff', border: 'none', borderRadius: 12, padding: '1rem', fontSize: '1rem', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', marginBottom: '0.75rem' },
  payOptions: { display: 'flex', gap: '0.5rem', marginBottom: '1.25rem' },
  payOpt: { flex: 1, padding: '0.6rem', borderRadius: 8, border: '1.5px solid #e2dbd0', background: '#faf7f2', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600, textAlign: 'center', transition: 'all 0.2s' },
  payOptActive: { borderColor: '#c0392b', background: '#fdf0ee', color: '#c0392b' },
  input: { width: '100%', padding: '0.75rem 1rem', border: '1.5px solid #e2dbd0', borderRadius: 10, fontSize: '0.9rem', outline: 'none', fontFamily: 'inherit', background: '#faf7f2', boxSizing: 'border-box', marginBottom: '0.75rem' },
  trust: { fontSize: '0.75rem', color: '#9c9189', textAlign: 'center', display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' },
  loading: { textAlign: 'center', padding: '5rem 2rem', color: '#7a6f65' },
  error: { background: '#fdf0ee', color: '#c0392b', padding: '0.85rem', borderRadius: 8, marginBottom: '1rem', fontSize: '0.875rem' },
  success: { background: '#edf7f2', color: '#1e6f3e', padding: '1rem', borderRadius: 10, textAlign: 'center', fontSize: '0.875rem', marginBottom: '1rem' },
};

export default function CampaignDetail() {
  const { id } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [donating, setDonating] = useState(false);
  const [gateway, setGateway] = useState('razorpay');
  const [amount, setAmount] = useState('');
  const [donorName, setDonorName] = useState('');
  const [donorEmail, setDonorEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    Promise.all([
      campaignAPI.getById(id),
      donationAPI.getCampaignDonations(id)
    ]).then(([c, d]) => {
      setCampaign(c.data);
      setDonations(d.data.content || []);
    }).catch(() => setError('Failed to load campaign.')).finally(() => setLoading(false));
  }, [id]);

  const handleDonate = async (e) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) < 10) { setError('Minimum donation is ₹10'); return; }
    setError(''); setDonating(true);
    try {
      const payload = { campaignId: parseInt(id), amount: parseFloat(amount), currency: campaign.currency, donorName, donorEmail, message, anonymous: !donorName };

      if (gateway === 'razorpay') {
        const { data } = await donationAPI.initiateRazorpay(payload);
        const options = {
          key: data.keyId, amount: parseFloat(amount) * 100, currency: data.currency,
          name: 'LayoffFund', description: `Donation to ${data.campaignTitle}`,
          order_id: data.orderId,
          handler: async (response) => {
            try {
              await donationAPI.verifyRazorpay(response.razorpay_order_id, response.razorpay_payment_id, response.razorpay_signature);
              setSuccessMsg('🎉 Thank you! Your donation was successful.');
              setAmount(''); setDonorName(''); setDonorEmail(''); setMessage('');
            } catch { setError('Payment verification failed. Contact support.'); }
          },
          prefill: { name: donorName, email: donorEmail },
          theme: { color: '#c0392b' },
        };
        const rzp = new window.Razorpay(options);
        rzp.open();
      } else {
        const { data } = await donationAPI.initiateStripe(payload);
        // In production: use Stripe Elements to confirm payment with data.clientSecret
        setSuccessMsg('Stripe payment initiated. Complete payment in the popup.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Payment failed. Please try again.');
    } finally { setDonating(false); }
  };

  if (loading) return <div style={s.loading}>Loading campaign...</div>;
  if (!campaign) return <div style={s.loading}>Campaign not found. <Link to="/campaigns">Browse all campaigns</Link></div>;

  const pct = Math.min(campaign.progressPercent, 100);
  const daysLeft = Math.max(0, Math.ceil((new Date(campaign.deadline) - new Date()) / 86400000));

  return (
    <div style={s.page}>
      <div style={s.grid}>
        <div>
          <div style={s.tag}>✓ Verified layoff</div>
          <h1 style={s.title}>{campaign.title}</h1>
          <div style={s.meta}>
            <div style={s.avatar}>{campaign.creatorName?.charAt(0)}</div>
            <div>
              <div style={s.creatorName}>{campaign.creatorName}</div>
              <div style={s.role}>{campaign.formerRole} · {campaign.formerCompany}</div>
            </div>
            {campaign.city && <span style={{ fontSize: '0.8rem', color: '#7a6f65' }}>📍 {campaign.city}</span>}
          </div>
          <p style={s.story}>{campaign.story}</p>

          {donations.length > 0 && (
            <div style={s.donorList}>
              <div style={s.donorTitle}>Recent donors</div>
              {donations.slice(0, 10).map(d => (
                <div key={d.id} style={s.donorItem}>
                  <div>
                    <div style={s.donorName}>{d.donorName || 'Anonymous'} {d.donorCountry && `· ${d.donorCountry}`}</div>
                    {d.message && <div style={s.donorMsg}>"{d.message}"</div>}
                  </div>
                  <div style={s.donorAmt}>{campaign.currency} {d.amount?.toLocaleString()}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={s.sideCard}>
          <div style={s.raised}>{campaign.currency} {campaign.raisedAmount?.toLocaleString()}</div>
          <div style={s.raisedSub}>raised of {campaign.currency} {campaign.goalAmount?.toLocaleString()} goal</div>
          <div style={s.progTrack}><div style={{ ...s.progFill, width: `${pct}%` }} /></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', color: '#7a6f65', marginBottom: '0.5rem' }}>
            <span>{pct}% funded</span><span>{daysLeft} days left</span>
          </div>
          <div style={s.statsRow}>
            <div style={s.statBox}><div style={s.statN}>{campaign.donorCount || 0}</div><div style={s.statL}>donors</div></div>
            <div style={s.statBox}><div style={s.statN}>{daysLeft}d</div><div style={s.statL}>remaining</div></div>
          </div>
          <div style={s.divider} />

          {successMsg && <div style={s.success}>{successMsg}</div>}
          {error && <div style={s.error}>{error}</div>}

          <div style={{ fontSize: '0.78rem', fontWeight: 600, color: '#3d3530', marginBottom: '0.6rem' }}>Pay with</div>
          <div style={s.payOptions}>
            {[['razorpay', 'UPI / Card'], ['stripe', 'Stripe']].map(([val, label]) => (
              <div key={val} style={{ ...s.payOpt, ...(gateway === val ? s.payOptActive : {}) }}
                onClick={() => setGateway(val)}>{label}</div>
            ))}
          </div>

          <form onSubmit={handleDonate}>
            <input style={s.input} type="number" placeholder={`Amount (${campaign.currency})`}
              value={amount} min="10" required onChange={e => setAmount(e.target.value)} />
            <input style={s.input} type="text" placeholder="Your name (optional)"
              value={donorName} onChange={e => setDonorName(e.target.value)} />
            <input style={s.input} type="email" placeholder="Email for receipt (optional)"
              value={donorEmail} onChange={e => setDonorEmail(e.target.value)} />
            <input style={s.input} type="text" placeholder="Leave a message (optional)"
              value={message} onChange={e => setMessage(e.target.value)} />
            <button style={s.donateBtn} type="submit" disabled={donating || !campaign.isActive}>
              {donating ? 'Processing...' : `Donate ${amount ? `${campaign.currency} ${amount}` : 'now'} →`}
            </button>
          </form>
          <div style={s.trust}>
            <span>🔒 Secure</span><span>✓ Verified campaign</span><span>💚 100% goes to recipient</span>
          </div>
        </div>
      </div>
    </div>
  );
}
